/**
 * Icon set (deliverable D7) — single stroke-weight, drawn from the world:
 * chip, tile, fan of cards, tansan cap, star-rank, sari-sari awning, padlock,
 * shield-heart, signal, miron eye.
 *
 * Paths are lifted verbatim from the Claude Design component sheet (option 1g)
 * so the web client and the exported Godot SVG sheet stay identical. Consumers
 * supply size and colour; `currentColor` replaces the sheet's hardcoded stroke.
 */
export const iconViewBox = '0 0 24 24';
/** Stroke geometry shared by the whole set — one weight, rounded joins. */
export const iconStroke = {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};
export const icons = {
    chip: '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21"/>',
    tile: '<rect x="5.5" y="3" width="13" height="18" rx="2.5"/><circle cx="12" cy="12" r="2.6"/>',
    baraha: '<rect x="3.5" y="6" width="9.5" height="13.5" rx="2" transform="rotate(-11 8.2 12.8)"/><rect x="11" y="4.5" width="9.5" height="13.5" rx="2" transform="rotate(10 15.8 11.2)"/>',
    tansan: '<circle cx="12" cy="12" r="8.5" stroke-dasharray="2.4 1.7"/><circle cx="12" cy="12" r="4.8"/>',
    rank: '<path d="M12 3.5l2.4 5.4 5.9.55-4.45 3.9 1.3 5.75L12 16.1l-5.15 2.95 1.3-5.75L3.7 9.45l5.9-.55z"/>',
    tindahan: '<path d="M4 7h16v3a2.65 2.65 0 0 1-5.3 0 2.65 2.65 0 0 1-5.3 0A2.7 2.7 0 0 1 4 10zM6 13.5V20M18 13.5V20M6 20h12"/>',
    kubo: '<rect x="6" y="11" width="12" height="9" rx="2"/><path d="M8.5 11V8a3.5 3.5 0 0 1 7 0v3"/><circle cx="12" cy="15.3" r="1.3"/>',
    responsible: '<path d="M12 3l7 2.5v5.2c0 4.9-3 7.9-7 9.8-4-1.9-7-4.9-7-9.8V5.5z"/><path d="M12 9.4c.9-1.7 3.3-1.2 3.3.7 0 1.6-1.9 2.9-3.3 3.9-1.4-1-3.3-2.3-3.3-3.9 0-1.9 2.4-2.4 3.3-.7z" fill="currentColor" stroke="none"/>',
    signal: '<path d="M4.5 10.5a10 10 0 0 1 15 0M7.5 13.8a5.6 5.6 0 0 1 9 0"/><circle cx="12" cy="17.5" r="1.4" fill="currentColor" stroke="none"/>',
    miron: '<ellipse cx="12" cy="12" rx="8.5" ry="5.4"/><circle cx="12" cy="12" r="2.4"/>',
    mic: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3M9 21h6"/>',
    /* Four corners pushing out, and the same four pulling back in. */
    expand: '<path d="M8.5 3.5H5A1.5 1.5 0 0 0 3.5 5v3.5M15.5 3.5H19A1.5 1.5 0 0 1 20.5 5v3.5M8.5 20.5H5A1.5 1.5 0 0 1 3.5 19v-3.5M15.5 20.5H19a1.5 1.5 0 0 0 1.5-1.5v-3.5"/>',
    collapse: '<path d="M3.5 8.5H7A1.5 1.5 0 0 0 8.5 7V3.5M20.5 8.5H17A1.5 1.5 0 0 1 15.5 7V3.5M3.5 15.5H7A1.5 1.5 0 0 1 8.5 17v3.5M20.5 15.5H17a1.5 1.5 0 0 0-1.5 1.5v3.5"/>',
};
//# sourceMappingURL=icons.js.map